import { useContext, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { getUserPreference, setUserPreference } from 'services/user-preferences-service';

import { PublicPageContext } from 'context/PublicPageContext';
import { LocaleContext } from 'context/LocaleContext';

import Discussion from 'components/discussion';

import IconDiscussionAlt from 'icons/icon-discussion-alt';
import IconToggle from 'icons/icon-toggle';

const TASK_DISCUSSION_UTILS = ['emoji', 'file', 'doc', 'voice'];

const EmptyComponent = () => (
    <div className="discussion-placeholder">
        <div className="message placeholder-with-content">
            <div className="message-inner">
                <div className="message-side">
                    <div className="message-user">
                        <span className="placeholder-particle" />
                    </div>
                </div>

                <div className="message-main">
                    <p>
                        <Trans i18nKey="chat:empty.comments" />
                    </p>
                </div>
            </div>
        </div>
    </div>
);

const TaskDiscussion = ({ id, projectId, projectUsers, withScrollTo, hideOnLarge, commentsCount, onNewComment, onDiscussionFocus }) => {
    const { t } = useTranslation(['chat', 'notifications']);
    const localeCtx = useContext(LocaleContext);
    const publicPageCtx = useContext(PublicPageContext);
    const isPublic = publicPageCtx?.isPublic === true;
    const [activityVisible, setActivityVisible] = useState(getUserPreference('task_activity_visible') || false);

    const handleToggleActivityClick = () => {
        setUserPreference('task_activity_visible', !activityVisible);

        setActivityVisible(prevState => !prevState);
    }

    if (!id || publicPageCtx?.pageConfig?.tasks?.show_comments === false) {
        return null;
    }

    return (
        <div className={'content-panel-section section-comments' + (hideOnLarge ? ' hide-on-large' : '')} data-section="comments">
            <div className="section-head">
                <h4>
                    <span className="title-icon"><IconDiscussionAlt /></span>

                    <span className="text">{ t('chat:Comment_count', { count: commentsCount }) }</span>
                </h4>

                <div className="section-actions">
                    <button className="btn btn-small section-action-btn" onClick={handleToggleActivityClick}>
                        <IconToggle />

                        {
                            activityVisible ? t('notifications:Hide Activity') : t('notifications:Show Activity')
                        }
                    </button>
                </div>
            </div>

            <div className="section-body">
                <Discussion
                    key={id}
                    id={id}
                    projectId={projectId}
                    type="task"
                    inputPlaceholer={t('placeholder.comment')}
                    dateFormat={localeCtx.dateTimeFormats.dateTime}
                    autofocus={false}
                    excludeRemoved={true}
                    botUseUserName={true}
                    smallerSystem={true}
                    directUpload={true}
                    hideSystem={!activityVisible}
                    utils={TASK_DISCUSSION_UTILS}
                    canSendAsEmail={true}
                    canSendMessage={!isPublic}
                    users={projectUsers}
                    emptyComponent={<EmptyComponent />}
                    onNewMessage={withScrollTo ? onNewComment : undefined}
                    onFocus={withScrollTo ? onDiscussionFocus : undefined}
                />
            </div>
        </div>
    );
}

export default TaskDiscussion;
